<template>
	<div class="survey">
			
			<!--<b-modal id="setpassword" title="Change Password" ok-only @hidden="resetSelectedForm" >-->
			<b-modal id="surveypopup" title="Survey"   ok-only   hide-header hide-footer no-close-on-backdrop size="md" centered>
			<div  class="surveypop">
				<!-- <template #modal-header>
				   
				  <h5 class="modal-title"> POP HEADER </h5>
				 
				  <button type="button" aria-label="Close" @click="$root.closeMeShareModel('showShareModal')" class="close">×</button>
				</template> @click="$bvModal.hide('bv-modal-example')" -->
				
				<!--<div class="text-right"> <button type="button" aria-label="Close" class=" closeMe" @click="$bvModal.hide('surveypopup')">×</button></div> -->
				<!--<div class="text-right"> <b-link  class=" closeMe" @click="$bvModal.hide('surveypopup'),remindmelater()">×</b-link></div> -->
				<b-row class="surveyP1">
					<b-col class="text-center p-0">
							<h6 class="font-bold text-center text-3xl mb-0" >Thank you for visiting Alluraa. The social eCommerce Platform.</h6>
							<p>We value your feedback. Please help us serve you better through this survey.</p>
					</b-col>
				</b-row>
				
				
				<b-row class="surveyP2">
					<b-col class="p-0">
						<ul >
							<li>1) Did you get what you were looking for?</li>
							<li>
								<b-form-group >
								  <b-form-radio-group
									v-model="question.question01"
									:options="optionsYesno"
									name="question01"
									plain
									class="yesnoBtn"
								  ></b-form-radio-group>
								</b-form-group>
							
							</li>
						</ul>
						<ul >
							<li>2) What were you looking for?</li>
							<li>
								<b-form-group v-slot="{ ariaDescribedby2 }">
								  <b-form-radio-group
									v-model="question.question02"
									:options="optionsQ2"
									:aria-describedby="ariaDescribedby2"
									name="question02"
									plain
								  ></b-form-radio-group>
								</b-form-group>
							
							</li>
						</ul>
						<ul >
							<li>3) Did you find enough range of products?</li>
							<li>
								<b-form-group v-slot="{ ariaDescribedby }">
								  <b-form-radio-group
									v-model="question.question03"
									:options="optionsYesno"
									:aria-describedby="ariaDescribedby"
									name="question03"
									plain
									class="yesnoBtn"
								  ></b-form-radio-group>
								</b-form-group>
							
							</li>
						</ul>
						<ul >
							<li>4) Did you find enough product details?</li>
							<li>
								<b-form-group v-slot="{ ariaDescribedby }">
								  <b-form-radio-group
									v-model="question.question04"
									:options="optionsYesno"
									:aria-describedby="ariaDescribedby"
									name="question04"
									plain
									class="yesnoBtn"
								  ></b-form-radio-group>
								</b-form-group>
							
							</li>
						</ul>
						<ul >
							<li>5) Did you find product details enough?</li>
							<li>
								
								<b-form-group >
								 <b-form-radio-group
									id="btn-radios-question05"
									v-model="question.question05"
									:options="options11"
									name="question05"
									size="sm"
									buttons
									class="mybtnstyl"
								  ></b-form-radio-group>
								  </b-form-group>
							
							</li>
						</ul>
						<ul >
							<li>6) How satisfied are you with the availability of products?</li>
							<li>
								
								<b-form-group >
								 <b-form-radio-group
									id="btn-radios-question06"
									v-model="question.question06"
									:options="options11"
									name="question06"
									
									size="sm"
									buttons
									class="mybtnstyl"
									plain
								  ></b-form-radio-group>
								  </b-form-group>
							
							</li>
						</ul>
						<ul >
							<li>7) How do you rate the quality of our products as compared to our competitors?</li>
							<li>
								
								<b-form-group >
								 <b-form-radio-group
									id="btn-radios-question07"
									v-model="question.question07"
									:options="options11"
									name="question07"
									
									size="sm"
									buttons
									class="mybtnstyl"
									plain
								  ></b-form-radio-group>
								  </b-form-group>
							
							</li>
						</ul>
						
						<ul >
							<li>8) Considering your complete experience with our platform, how likely would you recommend us to a friend or colleague?</li>
							<li>
								<b-form-group >
								 <b-form-radio-group
									id="btn-radios-question08"
									v-model="question.question08"
									:options="options11"
									name="question08"
									size="sm"
									buttons
									class="mybtnstyl"
									
								  ></b-form-radio-group>
								  </b-form-group> 
							
							</li>
						</ul>
						<!--<p class=" mb-4 text-xs">{{question}}</p> -->
							
					</b-col>
				</b-row>
				<b-row class="m-0">
					<b-col class="text-left pl-0">
						
						<b-button @click="$bvModal.hide('surveypopup'),remindmelater(),closeWindow()"  class=" text-xs w-full  block rounded  visited:text-white bg-red-700 font-bold" variant="light" style="border:1px solid #c6c6c670;" >Remind me later</b-button>
						
					</b-col>
					<b-col class="text-center p-0">
						
							<b-button  class="w-100 text-xs w-full  block rounded text-white visited:text-white bg-red-700 font-bold submitfeedback" @click="remindmelater()" style="font-weight: 600;">Submit Feedback</b-button>
							<!--@click="remindmelater()"-->
							
					</b-col>
				</b-row>
				
				</div>
				
					<!-- <b-link :href="urlLink" >
					 <b-img-lazy  fluid  rounded alt="surveypopup" :src="$root.MEDIAPATH+'/images/cONTESTPopUpBanner.jpeg'"></b-img-lazy> </b-link> 
					 
					 <div class="text-center"> <button type="button" class=" closeRem" @click="remindmelater()">Remind me later</button></div>-->
				
				
			  </b-modal>
			

	</div>		
</template>
<script>

/* setpassword

http://localhost:8080/agent/dashboard/setpassword*/

//import CartVariant from "@/components/cartVariant.vue";
//import ProductRating from "@/components/product-rating.vue";
import '../assets/surveypopup.scss';

export default {
  name: 'ShareEmailPopup',
  components: {
  //"cart-variant": CartVariant,
  //"product-rating": ProductRating,
  
  },
  created(){
	
  },
  mounted(){
    this.inLodcard();
	var roleIdmy =this.$root.customer_info.role;
	if(roleIdmy>0){
		this.myrole=roleIdmy;
		this.urlLink='/agent/my-shop';
	}
  },
  computed: {
    
  },
  data() {
    return{
		 userIdUri:'', 
		 coform_password: '', 
      new_password: '', 
	  coform_passwordState: null, 
      new_passwordState:null, 
      passwordUrl: this.$root.WEBAPI+'webapi/passwordSet',
      urlprmoCoutUrl: this.$root.WEBAPI+'webapi/postsurvey',
		linkComments:'',
		iamiconfor:'',
		register: {
				new_password:'',
				conformpassword:'',
				rowId:'',
				user_id:'',
            },
			registerState:{
				new_password:null,
				conformpassword:null,
			},
			registerError:{
				new_password:'Please enter password!',
				conformpassword:'Please reenter password!',
			},
			urlLink:'/login',
			myrole:0,
			question:{question01:'',
					 question02:'',
					 question03:'',
					 question04:'',
					 question05:'',
					 question06:'',
					 question07:'',
					 question08:'',
					 },
			
			optionsYesno: [
			  { text: 'Yes', value: '1' },
			  { text: 'No', value: '0' }
			],
			optionsQ2: [
			  { text: 'Apparel', value: 'Apparel' },
			  { text: 'Cosmetics', value: 'Cosmetics' },
			  { text: 'Home Decor', value: 'Home Decor' },
			  { text: 'Organic Products', value: 'Organic Products' },
			  { text: 'Others', value: 'Others' }
			],
			options10: [
			  { text: '1', value: '1' },
			  { text: '2', value: '2' },
			  { text: '3', value: '3' },
			  { text: '4', value: '4' },
			  { text: '5', value: '5' },
			  { text: '6', value: '6' },
			  { text: '7', value: '7' },
			  { text: '8', value: '8' },
			  { text: '9', value: '9' },
			  { text: '10', value: '10' },
			  
			],options11: [
			  { text: 'Poor', value: 'Poor' },
			  { text: 'Fair', value: 'Fair' },
			  { text: 'Good', value: 'Good' },
			  { text: 'Very Good', value: 'Very Good' },
			  { text: 'Excellent', value: 'Excellent' }
			]
		
    }
  },
  methods:{
	/* inLodcard(){
		alert('dasd');
	},*/
	inLodcard(){			
			//this.linkComments = this.social_options[this.$root.share.social];
			this.userIdUri = this.$route.params.userId;
			//console.log('userIdUri'+this.userIdUri); 
		},
		changeMessage(arg){		  
            //console.log('CHANGE MESSAGE '+social_options[$root.share.social]);
            this.linkComments = this.social_options[arg];
			
        },
		
		remindmelater(){
			var self=this;
			//this.$root.remindmelater = 1;
			//this.$root.customer_info.remindmelater;
			//self.$session.set('remindmelater',1);
			self.$bvModal.hide('surveypopup');
			var userIdlogin = self.$root.customer_info.user_id;
			if(typeof(self.userIdUri)!="undefined"){
				userIdlogin =  atob(self.userIdUri);
			}
			
				self.axios.post(self.urlprmoCoutUrl, {
					  accesskey: self.$root.customer_info.access_key,
					  user_id : userIdlogin,
					  question : self.question
				  }).then(function (response) {
					  if(response.data.error == 0 || response.data.error == '0'){
						 
						 console.log('count'); 
						 if(typeof(self.userIdUri)!="undefined"){
							//self.$router.push('/');
							window.location.href = '/';
						 }
					  }
				  }).catch(function (error) {
					  alert(error);
					 
				  });
			
			
		},
		closeWindow(){
			window.close();
			//opener.window.focus();
			
		}

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
	
	
</style>
